const C = require("../constants");

const openModalProductIngredients = modal => {
    return {
        type: C.OPEN_MODAL_PRODUCT_INGREDIENTS,
        modal
    }
};

export {openModalProductIngredients};


// WEBPACK FOOTER //
// ./src/actions/ModalProductIngredientsActions.js